// src/pages/PublicDashboard.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from './logo.png';

const PublicDashboard = () => {
  const [heroPhone, setHeroPhone] = useState('');
  const [heroSmsConsent, setHeroSmsConsent] = useState(false);

  const [bottomPhone, setBottomPhone] = useState('');
  const [bottomSmsConsent, setBottomSmsConsent] = useState(false);

  const testimonials = [
    {
      id: 1,
      name: "Christopher T.",
      text: "Flex was, well, super flexible! Had to arrange pick up from another state with some local help. Took a few tries to make the schedules happen but we made it happen. Our piece arrived intact after a IL-WA move and the team was super communicative and helpful!",
      rating: 5
    },
    {
      id: 2,
      name: "Billy J.",
      text: "I had a atv hauled over 2,000 miles. Rene was great to work with and the item arrived in great condition. I would definitely use him again.",
      rating: 5
    },
    {
      id: 3,
      name: "Troy F.",
      text: "Communication was great, I got my package fast and undamaged. I highly recommend.",
      rating: 5
    }
  ];

  const services = [
    {
      title: "Household Moves",
      description: "Full-service residential moving for apartments, homes, and condos across the US.",
      icon: "🏠"
    },
    {
      title: "Motorcycle Shipping",
      description: "Specialized secure transport for motorcycles with proper tie-downs and protection.",
      icon: "🏍️"
    },
    {
      title: "Special Items",
      description: "Safe transport for furniture, electronics, antiques, and other personal belongings.",
      icon: "📦"
    }
  ];

  const renderStars = (rating) => {
    return '★'.repeat(rating) + '☆'.repeat(5 - rating);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-purple-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl font-bold mb-6">
                Professional Specialized Shipping & Moving
              </h1>
              <p className="text-xl mb-6 text-blue-100">
                Trusted specialized item and household moving transport across the US. 
                Currently serving routes from the Northwest to Midwestern and vice versa with care and reliability.
              </p>

              {/* Compliant Web Form Opt-In Card */}
              <div className="mb-6 text-left bg-white/10 backdrop-blur-sm p-5 rounded-xl border border-white/20 text-xs sm:text-sm">
                <div className="mb-3">
                  <label htmlFor="heroPhone" className="block font-semibold uppercase tracking-wider text-blue-100 mb-1 text-xs">
                    Mobile Phone Number*
                  </label>
                  <input
                    type="tel"
                    id="heroPhone"
                    placeholder="(555) 123-4567"
                    value={heroPhone}
                    onChange={(e) => setHeroPhone(e.target.value)}
                    className="w-full px-4 py-2.5 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm font-medium"
                  />
                </div>

                <div className="space-y-2 text-white/90">
                  <label className="flex items-start gap-2.5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={heroSmsConsent}
                      onChange={(e) => setHeroSmsConsent(e.target.checked)}
                      className="mt-0.5 h-4 w-4 rounded text-blue-600 focus:ring-blue-500 border-gray-300 flex-shrink-0 cursor-pointer"
                    />
                    <span>
                      Yes, I would like to receive recurring automated SMS account updates, notifications, and verification codes from Flex Logistics Management.
                    </span>
                  </label>

                  <p className="text-blue-100 pl-6 leading-relaxed">
                    <strong>Message Frequency:</strong> Message frequency varies.<br />
                    <strong>Standard Rates:</strong> Message and data rates may apply depending on your mobile phone service plan.<br />
                    <strong>Help & Stop:</strong> Reply HELP for help or STOP to cancel any time.<br />
                    <strong>Privacy Commitment:</strong> Mobile information and messaging consent will not be shared with third parties or affiliates for marketing or promotional purposes.<br />
                    By providing your phone number and checking the box above, you agree to receive text messages from Flex Logistics Management.
                  </p>

                  <div className="pl-6 pt-1 text-xs text-blue-200">
                    <a href="/terms" target="_blank" rel="noopener noreferrer" className="underline hover:text-white">Terms &amp; Conditions</a> | <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" className="underline hover:text-white">Privacy Policy</a>
                  </div>
                </div>
              </div>

              {/* Hero Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/quote"
                  className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-50 transition-colors duration-200 text-center shadow-lg"
                >
                  Yes, sign me up!
                </Link>
                <Link
                  to="/shipping-form"
                  className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-blue-600 transition-colors duration-200 text-center"
                >
                  Book Your Shipment Now
                </Link>
              </div>
            </div>

            <div className="flex justify-center">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <img 
                  src={logo} 
                  alt="Flex Logistics Management" 
                  className="rounded-lg shadow-2xl"
                />
                <p className="text-center mt-4 text-blue-100">
                  Serving the USA • Northwest to Midwestern Routes
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Our Specialized Services
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We focus on what we do best: safe, reliable transport of your personal items, vehicles, and household goods.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="text-4xl mb-4">{service.icon}</div>
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-lg">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
          
          {/* Service Area Highlight */}
          <div className="mt-16 bg-white rounded-2xl shadow-lg p-8 text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Current Service Area
            </h3>
            <p className="text-xl text-gray-600 mb-4">
              We're currently specializing in routes between the <strong>Northwest and Midwestern</strong>, serving United States.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
              <div className="bg-blue-50 p-4 rounded-lg">
                <h4 className="font-semibold text-blue-800">Northwest Regions:</h4>
                <p className="text-gray-700">Washington, Oregon, Idaho, Montana</p>
              </div>
              <div className="bg-green-50 p-4 rounded-lg">
                <h4 className="font-semibold text-green-800">Midwestern Regions:</h4>
                <p className="text-gray-700">Minnesota, Illinois, Indiana, Michigan, Kansas, Missouri, Ohio, Kentucky, Iowa, Nebraska, Colorado</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-blue-600 mb-2">500+</div>
              <div className="text-gray-600">Successful Moves</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-blue-600 mb-2">15+</div>
              <div className="text-gray-600">States Served</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-blue-600 mb-2">24/7</div>
              <div className="text-gray-600">Customer Support</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-blue-600 mb-2">99%</div>
              <div className="text-gray-600">On-time Delivery</div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">
              Customer Success Stories
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Hear from families and individuals who trusted us with their important moves and shipments.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="bg-gray-800 p-8 rounded-2xl">
                <div className="text-yellow-400 text-lg mb-4">
                  {renderStars(testimonial.rating)}
                </div>
                <p className="text-gray-300 text-lg mb-6 italic">
                  "{testimonial.text}"
                </p>
                <div>
                  <div className="font-semibold text-white">{testimonial.name}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom CTA Section */}
      <section className="py-20 bg-blue-600 text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-6">
            Ready to Make Your Move Stress-Free?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Get a customized quote for your household move, motorcycle shipment, or special item transport.
          </p>

          {/* Compliant Web Form Opt-In Card */}
          <div className="max-w-2xl mx-auto mb-8 text-left bg-white/10 backdrop-blur-sm p-5 rounded-xl border border-white/20 text-xs sm:text-sm">
            <div className="mb-3">
              <label htmlFor="bottomPhone" className="block font-semibold uppercase tracking-wider text-blue-100 mb-1 text-xs">
                Mobile Phone Number*
              </label>
              <input
                type="tel"
                id="bottomPhone"
                placeholder="(555) 123-4567"
                value={bottomPhone}
                onChange={(e) => setBottomPhone(e.target.value)}
                className="w-full px-4 py-2.5 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm font-medium"
              />
            </div>

            <div className="space-y-2 text-white/90">
              <label className="flex items-start gap-2.5 cursor-pointer">
                <input
                  type="checkbox"
                  checked={bottomSmsConsent}
                  onChange={(e) => setBottomSmsConsent(e.target.checked)}
                  className="mt-0.5 h-4 w-4 rounded text-blue-600 focus:ring-blue-500 border-gray-300 flex-shrink-0 cursor-pointer"
                />
                <span>
                  Yes, I would like to receive recurring automated SMS account updates, notifications, and verification codes from Flex Logistics Management.
                </span>
              </label>

              <p className="text-blue-100 pl-6 leading-relaxed">
                <strong>Message Frequency:</strong> Message frequency varies.<br />
                <strong>Standard Rates:</strong> Message and data rates may apply depending on your mobile phone service plan.<br />
                <strong>Help & Stop:</strong> Reply HELP for help or STOP to cancel any time.<br />
                <strong>Privacy Commitment:</strong> Mobile information and messaging consent will not be shared with third parties or affiliates for marketing or promotional purposes.<br />
                By providing your phone number and checking the box above, you agree to receive text messages from Flex Logistics Management.
              </p>

              <div className="pl-6 pt-1 text-xs text-blue-200">
                <a href="/terms" target="_blank" rel="noopener noreferrer" className="underline hover:text-white">Terms &amp; Conditions</a> | <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" className="underline hover:text-white">Privacy Policy</a>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/quote"
              className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-50 transition-colors duration-200 inline-block shadow-lg"
            >
              Yes, sign me up!
            </Link>
            <Link
              to="/shipping-form"
              className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-blue-600 transition-colors duration-200 inline-block"
            >
              Book Your Shipment Now
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PublicDashboard;